import $ from '@vaersaagod/tools/Dom';

export default video => {
    let fallbackInterval = 0;

    const destroy = () => {
        stopFallback();
        video.pause();
        video.removeEventListener('timeupdate', timeupdate);
    };

    const timeupdate = () => {
        if (video.currentTime > 0.001) {
            video.removeEventListener('timeupdate', timeupdate);
            $(video).addClass('playing');
        }
    };

    const cantPlayVideo = () => {
        destroy();
        $(video).remove();
    };

    const startFallback = () => {
        fallbackInterval = setTimeout(cantPlayVideo, 2000);
    };

    const stopFallback = () => {
        if (fallbackInterval) {
            clearTimeout(fallbackInterval);
            fallbackInterval = 0;
        }
    };

    const playAndCatch = () => {
        const promise = video.play();
        if (promise !== undefined) {
            promise.then(() => {
                stopFallback();
            }).catch(e => {
                if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
                    cantPlayVideo();
                }
            });
        }
    };

    const init = () => {
        if (!video.canPlayType || !video.canPlayType('video/mp4')) {
            cantPlayVideo();
            return;
        }
        video.addEventListener('timeupdate', timeupdate);
        video.muted = true;
        playAndCatch();
        startFallback();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/AutoplayVideo.js